module.exports = __webpack_public_path__ + "static/Odgazowywacze-termoczne-kaskadowe-typu-ODT-0639e7ad9af7112a9e3a38dd51b835cf.pdf";